import { useTranslation } from "react-i18next";

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: "ri-flashlight-line",
      titleKey: "feat_instant_title",
      descKey: "feat_instant_desc",
      highlight: true,
    },
    {
      icon: "ri-apps-2-line",
      titleKey: "feat_services_title",
      descKey: "feat_services_desc",
      highlight: false,
    },
    {
      icon: "ri-global-line",
      titleKey: "feat_multicurrency_title",
      descKey: "feat_multicurrency_desc",
      highlight: false,
    },
    {
      icon: "ri-shield-check-line",
      titleKey: "feat_security_title",
      descKey: "feat_security_desc",
      highlight: false,
    },
    {
      icon: "ri-smartphone-line",
      titleKey: "feat_app_title",
      descKey: "feat_app_desc",
      highlight: false,
    },
  ];

  return (
    <section id="features" className="py-16 relative overflow-hidden section-alt">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-px bg-gradient-to-r from-transparent via-[#007AFF]/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#007AFF]/10 border border-[#007AFF]/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-[#007AFF] text-xs font-semibold tracking-wide uppercase">{t("feat_badge")}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
            {t("feat_title1")}
            <br />
            <span className="text-[#007AFF]">{t("feat_titleAccent")}</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            {t("feat_subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feature, idx) => (
            <div
              key={feature.titleKey}
              className={`relative group rounded-2xl p-6 border transition-all duration-300 cursor-pointer ${
                features.length % 3 !== 0 && idx === features.length - 1
                  ? "md:col-span-2 lg:col-span-1"
                  : ""
              } ${
                feature.highlight
                  ? "bg-[#007AFF]/5 border-[#007AFF]/30 accent-glow-sm"
                  : "bg-white border-gray-100 hover:border-[#007AFF]/25 hover:shadow-sm"
              }`}
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${
                  feature.highlight
                    ? "gradient-accent"
                    : "bg-[#eff6ff] group-hover:bg-[#007AFF]/10 transition-colors duration-300"
                }`}
              >
                <i className={`${feature.icon} text-xl ${feature.highlight ? "text-white" : "text-[#007AFF]"}`} />
              </div>

              <h3 className="text-gray-900 font-semibold text-base mb-1.5">{t(feature.titleKey)}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t(feature.descKey)}</p>

              {feature.highlight && (
                <div className="absolute top-5 right-5">
                  <span className="bg-[#007AFF] text-white text-xs font-bold px-2.5 py-1 rounded-full">{t("feat_popular")}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
